// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2r72a","box":"WorkspacesBox_box__3ahfR","node":"WorkspacesBox_node__2k889"};